// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"546":"598a09f2","594":"4ed164c5"}[chunkId] + ".chunk.css";
};